"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetch_1 = require("../utils/fetch");
exports.default = {
    getClientToken: function () {
        return fetch_1.default("/braintree/client-token", {
            method: "GET",
        });
    },
};
//# sourceMappingURL=braintree.js.map